module.exports = __webpack_public_path__ + "static/media/newLogo.8db12261.JPG";